var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M9.00002 2C5.14586 2 2 5.14586 2 9.00002C2 12.8542 5.14586 16 9.00002 16C10.748 16 12.345 15.3481 13.5743 14.2813L14 14.7071V16L19.586 21.586C20.138 22.138 21.034 22.138 21.586 21.586C22.138 21.034 22.138 20.138 21.586 19.586L16 14H14.7071L14.2813 13.5743C15.3481 12.345 16 10.748 16 9.00002C16 5.14586 12.8542 2 9.00002 2ZM9 4C11.7733 4 14 6.22673 14 9C14 11.7733 11.7733 14 9 14C6.22673 14 4 11.7733 4 9C4 6.22673 6.22673 4 9 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconFigma);
export default __webpack_public_path__ + "static/media/search-icon-figma.e0e351a560c764f4ad5efa2a38946d7c.svg";
export { ForwardRef as ReactComponent };